class ShopifyNavigation {
    /**
     * @param {Object} options - Configuration options
     * @param {string} options.buttonSelector - CSS selector for the button/anchor element
     * @param {string} options.targetUrl - URL to navigate to (can be relative for Shopify)
     * @param {string} options.scrollToSelector - CSS selector for the element to scroll to after navigation
     * @param {number} [options.scrollOffset=0] - Optional offset for scroll position
     * @param {number} [options.scrollDelay=300] - Delay in ms before scrolling after navigation (recommended higher for Shopify)
     */
    constructor(options) {
        this.buttonSelector = options.buttonSelector;
        this.targetUrl = options.getFullUrl ? this.getFullUrl(options.targetUrl) : options.targetUrl;
        this.scrollToSelector = options.scrollToSelector;
        this.scrollOffset = options.scrollOffset || 0;
        this.scrollDelay = options.scrollDelay || 300; // Increased delay for Shopify's AJAX navigation

        this.init();
    }

    // Helper to get full URL for Shopify (handles relative paths)
    getFullUrl(path) {
        if (path.startsWith('http')) return path;
        return `${window.location.origin}${path.startsWith('/') ? path : '/' + path}`;
    }

    init() {
        const buttons = document.querySelectorAll(this.buttonSelector);

        if (!buttons.length) {
            console.error(`Buttons with selector "${this.buttonSelector}" not found`);
            return;
        }

        buttons.forEach(button => {
            // Set the href attribute if it's an anchor tag
            if (button.tagName === 'A') {
                button.href = this.targetUrl;
            }

            // Add click event handler
            button.addEventListener('click', (e) => this.handleClick(e));
        });
    }

    handleClick(event) {
        event.preventDefault();

        // Store scroll target in sessionStorage
        if (this.scrollToSelector) {
            sessionStorage.setItem('shopifyScrollTo', JSON.stringify({
                selector: this.scrollToSelector,
                offset: this.scrollOffset,
                timestamp: Date.now() // Add timestamp to handle stale data
            }));
        }

        // Navigate to target URL
        window.location.href = this.targetUrl;
    }

    // Static method to check for scroll target on page load
    static checkForScroll() {
        const scrollData = sessionStorage.getItem('shopifyScrollTo');

        if (scrollData) {
            try {
                const { selector, offset, timestamp } = JSON.parse(scrollData);

                // Clear old data (older than 5 seconds) to prevent unwanted scrolling
                if (Date.now() - timestamp > 5000) {
                    sessionStorage.removeItem('shopifyScrollTo');
                    return;
                }

                const scrollToElement = () => {
                    const targetElement = document.querySelector(selector);

                    if (targetElement) {
                        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                        window.scrollTo({
                            top: elementPosition - (offset || 0),
                            behavior: 'smooth'
                        });
                    }

                    sessionStorage.removeItem('shopifyScrollTo');
                };

                // Delay execution to allow Shopify's AJAX to complete if needed
                setTimeout(scrollToElement, 300);
            } catch (e) {
                console.error('Error parsing scroll target data:', e);
                sessionStorage.removeItem('shopifyScrollTo');
            }
        }
    }

    // Initialize scroll check on page load (for Shopify theme)
    static initScrollCheck() {

        document.addEventListener('DOMContentLoaded', ShopifyNavigation.checkForScroll);
        window.addEventListener('load', ShopifyNavigation.checkForScroll);
    }
}


// Initialize scroll check on page load (MUST be called for scroll-after-navigation to work)
ShopifyNavigation.initScrollCheck();

document.addEventListener('DOMContentLoaded', () => {
    new ShopifyNavigation({
        buttonSelector: "a[href='#findUs']",
        targetUrl: '/',
        scrollToSelector: '.store-locator-cta__bg',
        scrollOffset: 150,
    });
    new ShopifyNavigation({
        buttonSelector: "a[href='#featuredProducts']",
        targetUrl: '/',
        scrollToSelector: '.featured-products-inner',
        scrollOffset: 150,
    });
    new ShopifyNavigation({
        buttonSelector: "a[href='#faq']",
        targetUrl: '/pages/contact',
        scrollToSelector: '.faq-section',
        scrollOffset: 150,
    });
    new ShopifyNavigation({
        buttonSelector: "a[href='#whoWeAre']",
        targetUrl: '/',
        scrollToSelector: '.who-we-are__container',
        scrollOffset: 150,
    });
    new ShopifyNavigation({
        buttonSelector: "a[href='#retailProducts']",
        targetUrl: '/pages/retail',
        scrollToSelector: '.retail-products-inner',
        scrollOffset: 150,
    });
    new ShopifyNavigation({
        buttonSelector: "a[href='#contactForm']",
        targetUrl: '/pages/contact',
        scrollToSelector: '.custom-contact-form',
        scrollOffset: 150,
    });
});
